import { useRecordContext } from 'react-admin';
import get from 'lodash/get';
import { FCRAWorkerAddressEnum } from '@/types/turn-enums';
import { TypographyStyled } from './styled';
import { TextColumnProps } from './types';

const TextColumn = ({ source, ...props }: TextColumnProps) => {
  const record = useRecordContext();

  const isCurrentAddress = get(record, FCRAWorkerAddressEnum.IsCurrentAddress);

  return (
    <TypographyStyled component="span" highlight={`${isCurrentAddress}`} {...props}>
      {get(record, source)}
    </TypographyStyled>
  );
};

export default TextColumn;
